import { BoxStyleProps } from "@twilio-paste/core/box";

export const endChatButtonStyles: BoxStyleProps = {
    width: "130px",
    marginBottom: "space50",
    marginTop: "space50",
    marginLeft: "space50"
};
